// extracted by mini-css-extract-plugin
module.exports = {"proposals":"ProposalTable_proposals__2Zu98","subHeaderRow":"ProposalTable_subHeaderRow__3_z4P"};